// Orden de la única encuesta, según el formato semestral de conocimiento institucional.
const QUESTION_ORDER = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];

const AGREEMENT_OPTIONS = [
  "Muy en desacuerdo",
  "En desacuerdo",
  "Ni de acuerdo ni en desacuerdo",
  "De acuerdo",
  "Muy de acuerdo",
];

const YES_NO_OPTIONS = ["Sí", "No"];

const ALTERNATIVE_ORDER = {
  1: [
    "Dirección Servicio de Salud Magallanes",
    "Subdirección de Gestión y Desarrollo de Personas",
    "Subdirección de Gestión Asistencial",
    "Subdirección Administrativa y Financiera",
    "Subdirección de Recursos Físicos",
    "SAMU",
    "COSAM Miraflores",
    "Otra unidad",
  ],
  2: ["Titular", "Contrata", "Suplente/Reemplazo", "Otra"],
  3: ["Menos de 1 año", "Entre 1 y 5 años", "Entre 6 y 10 años", "Entre 10 y 20 años", "Más de 20 años"],
  4: AGREEMENT_OPTIONS,
  5: AGREEMENT_OPTIONS,
  6: AGREEMENT_OPTIONS,
  7: AGREEMENT_OPTIONS,
  8: AGREEMENT_OPTIONS,
  9: AGREEMENT_OPTIONS,
  10: AGREEMENT_OPTIONS,
  11: AGREEMENT_OPTIONS,
  12: AGREEMENT_OPTIONS,
  13: YES_NO_OPTIONS,
  14: YES_NO_OPTIONS,
  15: [
    "Reclutamiento y selección",
    "Desarrollo de personas",
    "Ambientes laborales saludables",
    "Todas las anteriores",
  ],
  16: [
    "Cumplir la jornada de trabajo y desempeñar personalmente el cargo",
    "Ausentarse sin autorización previa",
    "Delegar libremente las funciones propias del cargo",
    "Ninguna de las anteriores",
  ],
  17: [
    "Percibir las remuneraciones que correspondan al cargo",
    "Ausentarse del servicio sin justificación",
    "Negarse a cumplir instrucciones legítimas de la autoridad",
    "Utilizar bienes institucionales para fines particulares",
  ],
};

function normalizeText(value) {
  return String(value || "")
    .replace(/<[^>]*>/g, " ")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim()
    .replace(/^(?:[a-z]|\d{1,2})\s+/, "");
}

function rankAlternative(questionId, alternative) {
  const expected = ALTERNATIVE_ORDER[Number(questionId)] || [];
  const label = normalizeText(alternative && alternative.alternative && alternative.alternative.alternative);
  const rank = expected.findIndex(option => {
    const text = normalizeText(option);
    return label === text || label.startsWith(text + " ");
  });
  return rank === -1 ? Number.MAX_SAFE_INTEGER : rank;
}

export function orderSurveyAlternatives(questionId, alternatives) {
  return (Array.isArray(alternatives) ? alternatives : [])
    .map((alternative, index) => ({ alternative, index }))
    .sort((a, b) => rankAlternative(questionId, a.alternative) - rankAlternative(questionId, b.alternative) || a.index - b.index)
    .map(item => item.alternative);
}

export function orderSurveyQuestions(questions) {
  return (Array.isArray(questions) ? questions : [])
    .map((question, index) => ({ question, index }))
    .sort((a, b) => {
      const first = QUESTION_ORDER.indexOf(Number(a.question.id));
      const second = QUESTION_ORDER.indexOf(Number(b.question.id));
      const firstRank = first === -1 ? Number.MAX_SAFE_INTEGER : first;
      const secondRank = second === -1 ? Number.MAX_SAFE_INTEGER : second;
      return firstRank - secondRank || a.index - b.index;
    })
    .map(({ question }) => ({
      ...question,
      questions_alternatives: orderSurveyAlternatives(question.id, question.questions_alternatives),
    }));
}
